import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Row extends React.Component {
	static defaultProps = {
		isWrapped: true,
	};

	static propTypes = {
		isWrapped: PropTypes.bool,
	};

	render() {
		return this.props.children;
	}
}
